import { apiRoute, API_V1 } from '../helpers/api-route'
import { fetchWrapper } from '../helpers/fetch-wrapper'
import moment from 'moment'

export const labelledImagesService = {
  getLabelledImages,
  getAILabelledImages,
  download,
  getBatches,
  getLabelledImagesSingle,
  getAILabelledImagesSingle,
  downloadBatches
}

function getLabelledImages (projectId) {
  return fetchWrapper.get(`${apiRoute()}${API_V1}/admin/training/labels_reduced/${projectId}`)
}

function getLabelledImagesSingle (projectId, imgId) {
  return fetchWrapper.get(`${apiRoute()}${API_V1}/admin/training/labels_single/${projectId}/${imgId}`)
}

function getAILabelledImages (projectId) {
  return fetchWrapper.get(`${apiRoute()}${API_V1}/admin/training/labels_reduced/${projectId}/ai`)
}

function getAILabelledImagesSingle (projectId, imgId) {
  return fetchWrapper.get(`${apiRoute()}${API_V1}/admin/training/labels_single/${projectId}/ai/${imgId}`)
}

function download (_payload) {
  var eDate = moment(_payload.dateEnd).format('YYYY-MM-DD')
  var sDate = moment(_payload.dateStart).format('YYYY-MM-DD')

  return fetchWrapper.get(
    `${apiRoute()}${API_V1}/admin/training/images/download/yolo?projectId=${_payload.projectID}&start_date=${sDate}&end_date=${eDate}&pathology=${_payload.pathology}&all_images=${_payload.all_images}&is_json=${_payload.json}`
  )
}

function getBatches () {
  return fetchWrapper.get(`${apiRoute()}${API_V1}/admin/training/images/batch`)
}

function downloadBatches (payload) {
  // Token is no longer available in client JS (HttpOnly cookie).
  // Backend must verify the session cookie.
  window.open(`${apiRoute()}${API_V1}/admin/training/images/download_batch?key=${payload.key}`)
}
